const API_BASE_URL = process.env.REACT_APP_API_PREFIX
const api_version = `${API_BASE_URL}/api/v1`

export const usersLogin = `${api_version}/admin/login`;
export const verifyEmail = `${api_version}/admin/verifyEmail`;
export const getUsers = `${api_version}/admin/users`;
export const getDashboardData = `${api_version}/admin/dashboard-data`;
export const downloadExcelOfUsers = `${api_version}/admin/getUsersExcel`;
export const getUserDetails = `${api_version}/admin/users/details`;
export const updateUser = `${api_version}/admin/users/update-user`;
export const getUserBankDetails = `${api_version}/admin/users/get-user-bank-details`;
export const getUserLedgers = `${api_version}/admin/getLeadger`;
export const depositToUser = `${api_version}/admin/userDeposit`;
export const userWithdrawalRequests = `${api_version}/admin/get-user-transaction`;
export const approveWithdrawal = `${api_version}/admin/process-withdrawal-approval`;
export const rejectWithdrawal = `${api_version}/admin/process-withdrawal-rejection`;
export const getPlatformBalances = `${api_version}/admin/get-all-platform-balance`;
export const exportPlatformBalances = `${api_version}/admin/get-all-platform-balance/export`;
export const getUserAssets = `${api_version}/admin/get-users-by-asset`;
export const getAutoTransaction = `${api_version}/admin/get-auto-deposits`;
export const getDepositFees = `${api_version}/admin/get-deposit-fees`;
export const updateDepositFees = `${api_version}/admin/update-deposit-fees`;
export const getTradeFees = `${api_version}/admin/get-trade-fees`;
export const approveAchWithdrawal = `${api_version}/admin/aeropay-withdraw/approve`;
export const rejectAchWithdrawal = `${api_version}/admin/aeropay-withdraw/reject`;
export const listPlatformFees = `${api_version}/admin/platform-fees`;
export const getCountries = `${api_version}/countries`;
export const getAdminCountries = `${api_version}/admin/countries`;
export const getAvailableCountries = `${getAdminCountries}/available`;
export const getUseractivity = `${api_version}/admin/get-user-activity`;
export const getC2CCrypto = `${api_version}/admin/get-c2c-tradable-cryptos`;
export const updateC2CCrypto = `${api_version}/admin/update-c2c-tradable`;
export const getUserOverview = `${api_version}/admin/get-all-users-overview`;
export const exportUsersTransactions = `${api_version}/admin/get-all-users-overview/export`;
export const approveReferralDeposit = `${api_version}/admin/accept-referral-deposit`;
export const rejectReferralDeposit = `${api_version}/admin/reject-referral-deposit`;
export const getReferralSummary = `${api_version}/admin/referral-summary`;
export const getIncompleteOnboardingUsers = `${api_version}/admin/admin/users/incomplete-onboarding`;
export const deleteIncompleteOnboardingUser = `${api_version}/admin/admin/users/delete-incomplete-onboarding`;
export const getAdminAllSpins = `${api_version}/admin/spins`;
export const getUserSpinHistory = `${api_version}/admin/users`;
export const adjustSpins = `${api_version}/admin/spins/adjust`;
export const getSpinConfigStatus = `${api_version}/admin/spins/config-status`;
export const getAuditLogs = `${api_version}/admin/audit-logs`;
export const downloadAuditLogsExcel = `${api_version}/admin/audit-logs/export`;

// Push notification campaigns
export const pushBase = `${api_version}/admin/push`;
export const pushDestinations = `${pushBase}/destinations`;
export const pushAudienceUsers = `${pushBase}/audience/users`;
export const pushAudienceLocations = `${pushBase}/audience/locations`;
export const pushAudiencePreview = `${pushBase}/audience/preview`;
export const pushGroups = `${pushBase}/groups`;
export const pushCampaigns = `${pushBase}/campaigns`;
export const pushCampaignTest = `${pushBase}/campaigns/test`;
export const pushUserHistory = `${pushBase}/users`;
